<!--
 * @Description: 服务项目配置页面
 * @Author: sunhuihong
 * @Date: 2022-05-25 16:43:52
 * @LastEditTime: 2023-12-25 17:16:12
-->
<template>
  <div class="body">
    <el-row class="bk-search" style="margin: 25px 40px;" :gutter="0" type="flex" justify="space-between" >
      <el-col :span="8" style="text-align: left; ">
        <span class="search-title">服务类型：</span>
        <el-select size="small" filterable clearable v-model="filterParams.hserviceTypeCfgId"  placeholder="请选择"  
          style="width: 190px;">
          <el-option v-for="item in serviceTypeList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="8" style="text-align: center">
        <span class="search-title">服务名称：</span>
        <el-input size="small" style="width: 190px;" v-model="filterParams.hserviceCfgName" clearable 
          placeholder="请输入服务名称">
        </el-input>
      </el-col>
      <el-col :span="8" style="text-align: right;">
        <el-button size="small"  @click="handleQuery"  type="primary" icon="el-icon-search" style="width: 80px;">
          搜 索
        </el-button>
        <el-button v-if="dataPvgList.includes('HSVCCFG_1_CREATE')" size="small" @click="handleAddHserviceCfg" type="primary" icon="el-icon-plus" style="width: 80px;">
          新 增
        </el-button>
      </el-col>      
    </el-row>
    <div class="main-line"></div>
    <el-table style="margin: 0 40px; border: 1px solid #f0f0f0;" :style="tableWidth" ref="table" :data="dataTable" 
      :header-cell-style="{ 'text-align': 'left','background-color':'#EFF5FA'}">
      <el-table-column prop="name" label="服务名称" min-width="17%" align="left"></el-table-column>
      <el-table-column label="服务类型" min-width="17%" align="left">
        <template slot-scope="scope">
          {{scope.row.hserviceTypeCfgName == '' ? '- -' : scope.row.hserviceTypeCfgName}}
        </template>
      </el-table-column>
      <el-table-column prop="categoryName" label="服务类别" min-width="17%" align="left"></el-table-column>
      <el-table-column prop="insertTime" label="创建时间" sortable min-width="18%" align="left">
        <template slot-scope="scope">{{rebuildDate(scope.row.insertTime)}}</template>
      </el-table-column>
      <el-table-column prop="creatorName" label="创建人"  min-width="17%" align="left"></el-table-column>
      <el-table-column  label="操作" min-width="14%" align="left">
        <template slot-scope="scope">
          <el-button  type="text" size="small" @click="handleDetailHsvcCfg(scope.row)">详情</el-button>
          <template v-if="dataPvgList.includes('HSVCCFG_2_UPDATE')" >
            <el-divider direction="vertical"></el-divider>
            <el-button  type="text" size="small" @click="handleEditHsvcCfg(scope.row)">编辑</el-button>
          </template>
          <template v-if="dataPvgList.includes('HSVCCFG_3_DELETE')" >
            <el-divider direction="vertical"></el-divider>
            <el-button  type="text" size="small" @click="handleDeleteHsvcCfg(scope.row)">删除</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-row class="foot-pagination">
      <el-pagination :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber"  background  @size-change="handleSizeChange" 
        @current-change="handleCurPage" />
    </el-row>

    <!-- 服务配置服务项目详情弹框 -->
    <hsvc-cfg-details :showHsvcCfgDetails="showHsvcCfgDetails" :mode="dialogMode" :hsvcCfgItemId="hsvcCfgItemId" 
      @close-dialog="closeHsvcCfgDialog"/>
   
  </div>
</template>

<script>
import Util from '@/global/Util.js'
import Constant from '@/global/Constant.js'
import HsvcCfgDetails from './components/HsvcCfgDetails.vue'

export default {
  name: 'HsvcCfg',
  components: {
    'hsvc-cfg-details': HsvcCfgDetails,
  },

  data() {
    return {
      dataPvgList: [],    //在角色配置页面上的操作权限
      filterParams: {
        hserviceTypeCfgId: '',
        hserviceCfgName: '',
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      
      serviceTypeList: [],
      totalNumber: 0,
      dataTable: [],
      showHsvcCfgDetails: false,
      dialogMode: '', 
      hsvcCfgItemId: '',
    }
  },
  
  computed: {
    tableWidth() {
      return 'width:' + (this.$root.contentWidth - 80) + 'px';
    },
  },
  
  methods: {
    async initData() {
      await this.getDataPvg4CurRole();
      await this.getFilterDo();
      await this.listHsvcCfg();
    },

    getDataPvg4CurRole() {
      return new Promise((resolve) => {
        let requestData = {
          method: 'GET',
          url: this.commonUrl.URL_GET_DATA_PVG_4_CURROLE,
          param: {entityKey: 'HSVCCFG'},
        };
        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataPvgList = result.data;
            resolve();
          }
        })
      })
    },

    //查询过滤条件
    getFilterDo() {
      return new Promise((resolve) => {
        this.appAxios("GET", Constant.URL_GET_HSERVICE_CFG_FILTER_DO).then(result => {
          if (result != null) {
            this.serviceTypeList = Util.changeArrPosition(result.data);
            if (this.serviceTypeList.length) {
              this.$set(this.filterParams, 'hserviceTypeCfgId', this.serviceTypeList[0].id);
            }
            resolve();
          }
        })
      })
    },

    //获取table表格数据
    listHsvcCfg() {
      return new Promise((resolve) => {
        let header = this.encryptionUtil.signatureParams(this.filterParams,
          Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
        let requestData = {
          method: 'GET',
          url: Constant.URL_GET_HSERVICE_CFG_LIST,
          param: this.filterParams,
          header: header,
          contentType: this.commonConst.CNTYPE_URLENCODED,
        };

        this.vueRequest(requestData).then(result => {
          if (result != null) {
            this.dataTable = result.data;
            this.totalNumber = result.totalNumber;
            resolve();
          }
        })
      })
    },
    
    //搜索
    handleQuery() {
      this.filterParams.page = 1;
      this.listHsvcCfg();
    },
    
    //新增
    handleAddHserviceCfg() {
      this.showHsvcCfgDetails = true;
      this.dialogMode = "add";
      this.hsvcCfgItemId = 0;
    },

    //详情
    handleDetailHsvcCfg(item) {
      this.dialogMode = 'details';
      this.hsvcCfgItemId = item.id;
      this.showHsvcCfgDetails = true;
    },

    //编辑
    handleEditHsvcCfg(item) {
      this.showHsvcCfgDetails = true;
      this.dialogMode = 'edit';
      this.hsvcCfgItemId = item.id;
    },

    //删除
    handleDeleteHsvcCfg(item) {
      this.$confirm('删除不可撤回，确定删除?', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.deleteHsvcCfgList(item);
      })
    },

    deleteHsvcCfgList(item) {
      let params = {id: item.id};
      let header = this.encryptionUtil.signatureParams(params,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'DELETE',
        url: Constant.URL_DELETE_HSERVICE_CFG,
        param: params,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        this.listHsvcCfg();
      });
    },

    closeHsvcCfgDialog(refresh) {
      this.showHsvcCfgDetails = false;
      if (refresh) this.listHsvcCfg();
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.listHsvcCfg();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.listHsvcCfg();
    },

    rebuildDate(date) {
      return this.dateUtil.dateTimeFormat(date, "YYYY-MM-DD HH:mm");
    },
  },

  mounted() {
    this.$emit("breadcrumb", {text1: '服务配置', text2: '服务项目配置'});
    this.initData();
  }
}
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.search-title {
  color: #657180;
  font-size: 14px;
  display: inline-block;
  text-align: right;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
  margin: 15px 0 ;
}

.foot-pagination {
  margin-top: 57px;
  text-align: right;
  right: 40px;
  border: solid 0px;
}

.el-dropdown-link {
  cursor: pointer;
  color: #3E7EF5;
}

.el-dropdown-link-dis {
  cursor: pointer;
  color: #999999;
}
</style>


// WEBPACK FOOTER //
// src/components/hsvccfg/HsvcCfg.vue